import type React from 'react';

import { LivenessIcon } from '@vlabs/icons';
import type { WithDataTestid, WithClassNameProp } from '@vlabs/uikit/types';
import { useTranslation } from 'react-i18next';

import { AttributeCard } from './attribute-card/AttributeCard';

interface LivenessAttributeCardProps extends WithDataTestid, WithClassNameProp {
  liveness: 0 | 1 | 2 | null;
}

export function LivenessAttributeCard({
  liveness,
  className = undefined,
  'data-testid': dataTestId = 'LivenessAttributeCard',
  ...props
}: LivenessAttributeCardProps): React.JSX.Element {
  const { t } = useTranslation();

  let description: string;
  let color: 'positive' | 'negative' | null = null;

  if (liveness === null) {
    description = t('shared:attribute_cards.liveness.no_check');
  } else if (liveness === 0) {
    description = t('shared:attribute_cards.liveness.fake');
    color = 'negative';
  } else if (liveness === 1) {
    description = t('shared:attribute_cards.liveness.real');
    color = 'positive';
  } else {
    description = t('shared:attribute_cards.liveness.unknown');
  }

  const colorsConfig = [{ color, tooltip: null }];

  return (
    <AttributeCard
      className={className}
      colorsConfig={colorsConfig}
      data={liveness}
      data-testid={dataTestId}
      description={description}
      icon={<LivenessIcon />}
      title={t('shared:attribute_cards.liveness.title')}
      {...props}
    />
  );
}
